module.exports = __webpack_public_path__ + "static/media/Developement Cover.a97c1d26.JPG";